import { render, staticRenderFns } from "./NoDataFound.vue?vue&type=template&id=7258e6de"
import script from "./NoDataFound.vue?vue&type=script&lang=ts"
export * from "./NoDataFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports